import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'naas-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class HeaderComponent implements OnInit, AfterViewInit {
  showNavigation = true;

  // This toggles the hamburger menu
  hamburgerToggle() {
    const navMenu = document.getElementById('navigation');
    const hamburgerButton = document.getElementById('hamburgerButton');
    const contactDropdown = document.getElementById('contactDropdown');
    const currentState = hamburgerButton?.getAttribute('data-state');
    if (
      navMenu !== null &&
      typeof navMenu !== 'undefined' &&
      contactDropdown !== null &&
      typeof contactDropdown !== 'undefined'
    ) {
      if (typeof currentState === 'undefined' || currentState === 'closed') {
        navMenu.classList.add('responsive');
        navMenu.setAttribute('aria-expanded', 'true');
        hamburgerButton?.setAttribute('data-state', 'opened');
        hamburgerButton?.setAttribute('aria-expanded', 'true');
        contactDropdown.setAttribute('aria-expanded', 'true');
      } else {
        navMenu.classList.remove('responsive');
        navMenu.setAttribute('aria-expanded', 'false');
        hamburgerButton?.setAttribute('data-state', 'closed');
        hamburgerButton?.setAttribute('aria-expanded', 'false');
        contactDropdown.setAttribute('aria-expanded', 'false');
      }
    }
  }

  // The contact-us sub-menu "aria-expanded" toggle
  setExpanded(expanded = 'false') {
    const navMenu = document.getElementById('contactDropdown');
    if (navMenu !== null && typeof navMenu !== 'undefined') {
      navMenu.setAttribute('aria-expanded', expanded);
    }
  }

  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.updateNavigationVisibility(this.router.url);
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.updateNavigationVisibility(event.urlAfterRedirects);
    });
  }

  ngAfterViewInit(): void {
    const links = this.elRef.nativeElement.querySelectorAll('.topnav a');
    links.forEach((link: HTMLAnchorElement) => {
      if (link.href === window.location.href) {
        this.renderer.addClass(link, 'current-page');
        this.renderer.setAttribute(link, 'aria-current', 'page');
      }
    });
  }

  skipToMain(event: Event): void {
    event.preventDefault();
    let url = window.location.href;
    url = url.split('#')[0] + '#main_naas_content';
    window.location.href = url;
  }

  updateNavigationVisibility(url: string): void {
    this.showNavigation = !url.startsWith('/deep-link/');
  }
}
